__turbopack_context__.v({
  "container": "AppWrapper-module__-bQd0G__container",
  "content": "AppWrapper-module__-bQd0G__content",
  "publicContent": "AppWrapper-module__-bQd0G__publicContent",
  "publicHeader": "AppWrapper-module__-bQd0G__publicHeader",
  "sidebarIsClosed": "AppWrapper-module__-bQd0G__sidebarIsClosed",
  "sidebarIsOpen": "AppWrapper-module__-bQd0G__sidebarIsOpen",
});
